import type {
  HypotheticalFrequencyDataRow,
  HypotheticalFrequencyResultStatus
} from ".";
import { MAX_DELTA_REQUIRED_PRESSURE } from "../../constants";

export const doOneRow = (
  hypotheticalFrequencyHz: number,
  producedPressurePSIA: number,
  requiredPressurePSIA: number,
  depth: number,
  previousChange?: number
): HypotheticalFrequencyDataRow => {
  const pressureDifference = producedPressurePSIA - requiredPressurePSIA;
  const pressureDifferenceChange = previousChange
    ? pressureDifference - previousChange
    : undefined;
  const pressureDifferenceHasGrown = !!(
    pressureDifferenceChange && pressureDifferenceChange > 0
  );
  const isHealthy = producedPressurePSIA > requiredPressurePSIA;
  const withinTolerance =
    isHealthy &&
    producedPressurePSIA - requiredPressurePSIA < MAX_DELTA_REQUIRED_PRESSURE;

  // depth basically translates to the log10 power at play
  // the search go from 25 to 145, with a step size of .2
  // MAX_DEPTH is set to 8 to ensure that the algorithm will reach beyond
  // .00001 precision
  const MAX_DEPTH = 11;
  let status: HypotheticalFrequencyResultStatus;
  if (isHealthy && withinTolerance) {
    status = "result-found";
  } else if (isHealthy && !withinTolerance) {
    if (
      pressureDifferenceHasGrown &&
      depth <= MAX_DEPTH &&
      previousChange &&
      previousChange < 0
    ) {
      status = "threshold-found";
    } else if (pressureDifferenceHasGrown && depth > MAX_DEPTH) {
      status = "error: cannot find threshold hz";
    } else if (
      pressureDifferenceHasGrown &&
      depth <= MAX_DEPTH &&
      (!previousChange || previousChange >= 0)
    ) {
      status = "seeking-threshold";
    } else {
      status = "seeking-tolerance";
    }
  } else {
    status = "seeking-threshold";
  }

  return {
    hypotheticalFrequencyHz,
    producedPressurePSIA,
    requiredPressurePSIA,
    pressureDifference,
    pressureDifferenceChange,
    pressureDifferenceHasGrown,
    isHealthy,
    withinTolerance,
    depth,
    status
  };
};
